import { Navigate, useParams } from "react-router-dom";

/** Rota legada: resposta agora ocorre no detalhe (chat + inserir proposta). */
export default function QuoteAnswer() {
    const { id } = useParams();
    return <Navigate to={`/orcamento-detalhes/${id}`} replace />;
}
